import VuexPersist from 'vuex-persist';
import StorageService from '@/api/Storage';

const vuexUserStorage = new VuexPersist({
  key: 'user-storage',
  storage: StorageService,

  modules: [
    'authorization',
  ],
  restoreState: (key, storage) => storage[key],
});

export default vuexUserStorage;
